import axios from "axios";

import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * postContact
 *
 * Send user inquiries.
 *
 * @param name Name of the user who inquired.
 * @param email Mail address of the user who inquired.
 * @param category Type of inquiry.
 * @param message Details of inquiry.
 * @returns Result of sending inquiry.
 */

export const postContact = async (
  name: string,
  email: string,
  category: string,
  message: string
): Promise<boolean> => {
  try {
    const res = await axios.post(getAPIRoot(APIRoutes.post.contact), {
      sonic_name: name,
      sonic_email: email,
      sonic_category: category,
      sonic_message: message,
    });

    return res.data.result;
  } catch (e) {
    return false;
  }
};
